export default __webpack_public_path__ + "static/media/jumping4.5bf66bf4.jpg";